const CUSTOMER_ALREADY_LOGGED_ACTION =
    'GIL020: El usuario estaba logado validamente con lo que no hemos pedido el auth data desde el single use token',
  TOKEN_STATUS_CHECK_1_ACTION = 'Comprobando status de token 1',
  TOKEN_STATUS_CHECK_2_ACTION = 'Comprobando status de token 2',
  TOKEN_STATUS_CHECK_3_ACTION = 'Comprobando status de token 3',
  TOKEN_REFRESH_SETUP_CUSTOM_ACTION =
    'GIL017: Hemos configurado correctamente el proceso de refresco automatico del token de sesion del usuario.',
  TOKEN_REFRESHED_CUSTOM_ACTION =
    'GIL018: Hemos refrescado el token de sesión correctamente. Continua el usuario con el onboarding.',
  TOKEN_REFRESH_FAILED_CUSTOM_ACTION =
    'GIL019: Ha fallado el refresco del token de sesión, por lo que el onboarding no puede continuar, llevandole al usuario a la pantalla de error.';

export {
  CUSTOMER_ALREADY_LOGGED_ACTION,
  TOKEN_STATUS_CHECK_1_ACTION,
  TOKEN_STATUS_CHECK_2_ACTION,
  TOKEN_STATUS_CHECK_3_ACTION,
  TOKEN_REFRESH_SETUP_CUSTOM_ACTION,
  TOKEN_REFRESHED_CUSTOM_ACTION,
  TOKEN_REFRESH_FAILED_CUSTOM_ACTION,
};
